import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import withSideEffect from 'react-side-effect';

let clientInstance;

const reducePropsToState = propsList => {
  const blocks = {};
  propsList.forEach(({ id, children }) => {
    blocks[id] = children;
  });
  return blocks;
};

const handleStateChangeOnClient = blocks => {
  if (clientInstance) {
    clientInstance.setState({ blocks });
  }
};

const GlobalMarkup = withSideEffect(
  reducePropsToState,
  handleStateChangeOnClient,
)(() => null);

GlobalMarkup.propTypes = {
  children: PropTypes.element.isRequired,
  id: PropTypes.string.isRequired,
};

const renderGlobalMarkup = (blocks = {}) => Object.keys(blocks).map(key => (
  <Fragment key={key}>
    {blocks[key]}
  </Fragment>
));

export const Server = () => {
  const rendered = renderGlobalMarkup(GlobalMarkup.peek());
  GlobalMarkup.rewind();
  return rendered;
};

export class Client extends Component {
  state = {
    blocks: GlobalMarkup.peek() || {},
  };

  componentDidMount() {
    clientInstance = this;
  }

  componentWillUnmount() {
    clientInstance = undefined;
  }

  render() {
    const { blocks } = this.state;
    return renderGlobalMarkup(blocks);
  }
}

export default GlobalMarkup;
